import { z } from 'zod';

/**
 * The steps of the guided setup (scoping 3.4), in the order a new school walks them. Each is
 * computed from data; the list is the contract between the API and the wizard.
 */
export const SETUP_STEP_IDS = [
  'sede',
  'school-year',
  'periods',
  'grades',
  'groups',
  'subjects',
  'grading-scale',
  'fee-concepts',
  'consent-texts',
  'people',
  'teachers',
] as const;

/**
 * A step id as a path parameter.
 */
export const setupStepIdSchema = z.enum(SETUP_STEP_IDS);

/**
 * A step of the checklist.
 */
export type SetupStepId = (typeof SETUP_STEP_IDS)[number];

/**
 * One step as `GET /setup` answers it: derived state, the manual skip if any, and where the
 * app sends the user to complete it.
 */
export type SetupStepView = {
  id: SetupStepId;
  title: string;
  description: string;
  status: 'done' | 'pending' | 'skipped';
  done: boolean;
  skipped: boolean;
  skippedAt: string | null;
  count: number;
  link: string;
};

/**
 * The whole checklist with its progress; `ready` when nothing is pending.
 */
export type SetupState = {
  steps: SetupStepView[];
  progress: { done: number; skipped: number; pending: number; total: number; percent: number };
  ready: boolean;
  activeSchoolYear: { id: string; name: string } | null;
};
